import React from "react";
import { Modal, Box, Typography, Button, Stack, TextField } from "@mui/material";
import { useDeleteModal } from "./styles";
import { ConfirmModal } from "../ConfirmModal";
import { useTranslation } from "react-i18next";

interface CancelModalProps {
  open: boolean;
  onClose: () => void;
  onDelete: (comment: string) => Promise<void>;
  countFolios: string;
}

export const CancelModal: React.FC<CancelModalProps> = ({
  open,
  onClose,
  onDelete,
  countFolios,
}) => {
  const styles = useDeleteModal();
  const [confirmModalOpen, setConfirmModalOpen] = React.useState(false);
  const [comment, setComment] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const { t } = useTranslation()

  const handleOpenConfirmModal = () => {
    setConfirmModalOpen(true);
    onClose();
  };

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await onDelete(comment);
      setComment("");
      setConfirmModalOpen(false);
    } catch (error) {
      console.log(error)
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={styles.container}>
          <Typography variant="h6" component="h2" textAlign="center" mb={.2}>
            {t('reportFolio.detail.general.cancelMotive')}
          </Typography>

          <Stack direction="row" mb={2} alignItems="center" justifyContent="center">
            <Typography textAlign="center">
              {t('reportFolio.detail.general.cancelMotiveText', { countFolios: countFolios, count: Number(countFolios) })}
            </Typography>
          </Stack>

          <TextField
            fullWidth
            name="Comentario de cierre"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            label="Comentario de cierre"
            variant="outlined"
            multiline
            rows={6}
            InputProps={{
              style: {
                fontSize: '16px',
                alignItems: 'flex-start',
              },
            }}
            InputLabelProps={{
              style: {
                fontSize: '16px',
              },
            }}
          />

          <Stack direction="row" justifyContent="space-between" mt={4}>
            <Button variant="text" color="primary" onClick={() => {
              onClose()
              setComment("")
            }}>
              {t('reportFolio.detail.general.cancel')}
            </Button>
            <Button
              variant="contained"
              onClick={handleOpenConfirmModal}
              disabled={!comment.trim()}
              sx={styles.button}
            >
              {t('reportFolio.detail.general.cancelFolioConfirm')}
            </Button>
          </Stack>
        </Box>
      </Modal>

      <ConfirmModal
        open={confirmModalOpen}
        onClose={() => !isSubmitting && setConfirmModalOpen(false)}
        onConfirm={handleConfirm}
        title="Confirmación"
        description={t('reportFolio.detail.general.DeleteFolios', { count: Number(countFolios) })}
      />
    </>
  );
};